

import { NgModule, ErrorHandler, APP_INITIALIZER, Inject, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppEventMessagesService } from './services/application-state.service';


/*
import { HttpClientModule } from '@angular/common/http';
//import { AppMaterialModule } from './app-material/app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
*/

//FONTS & BOOTSTRAP
//import { AngularFontAwesomeModule } from 'angular-font-awesome';

//import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
//import { AccordionModule, PanelModule, ButtonModule, RadioButtonModule } from 'primeng/primeng';



import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/*ng 


import { CookieService } from 'ngx-cookie-service';
import { DatePipe } from '@angular/common';
*/


/*
import { FlatpickrModule } from 'angularx-flatpickr';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';


import { StoreModule } from '@ngrx/store';
import { reducer } from './services/userStore/user.reducer';
import { AgGridModule } from 'ag-grid-angular';
*/


import { StoreModule } from '@ngrx/store';
import { reducer } from './services/userStore/user.reducer';




//import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
/*
import { NgxMaterialTimepickerModule } from '../../node_modules/ngx-material-timepicker';
import { ChartsModule } from 'ng2-charts';
import { FileUploadModule } from 'ng2-file-upload';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
*/



//PRIME NG
//import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
//import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';






import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
//import { UpgradeModule, downgradeComponent, downgradeInjectable, setAngularJSGlobal  } from '@angular/upgrade/static';








//import { AppImportComponentsModule } from './app-import-list/app-import-components.module';
//import { AppImportServiceModule } from './app-import-list/app-import-service.module';




import { environment } from '../environments/environment';


/*

import { JL } from 'jsnlog';
import { ComponentsModule } from './components/components.module';
import { SigninComponent } from './pages/signin/signin.component';
*/

//PAGES
//import { WeatherCardComponent } from './pages/weather-card/weather-card.component';
//import { AddCardComponent } from './pages/add-card/add-card.component';
//import { DetailsComponent } from './pages/details/details.component';





/*
//HOME
import { HomeComponent } from './pages/home/home.component';

//IT TOOLS
import { ItToolsComponent } from './pages/it/it-tools/it-tools.component';



//COMPONENTS
import { HeaderComponentItrak } from './pages/quality/itrak/components/header/header.component'


//PROJECT LOG
import { ProjectLogSettingAccessComponent } from './pages/pmo/project-log/project-log-settings/project-log-setting-access/project-log-setting-access.component';

//TIME SHEET VALIDATION
import { TimeSheetValidationComponent } from './pages/hr/time-sheet-validation/time-sheet-validation.component';


//FINANCE
//import { FinanceReportsComponent } from './pages/finance/reports/reports.component';


//SETTINGS
import { SettingsComponent } from './pages/settings/settings.component';


import { DbStatusComponent } from './pages/settings/db-status/db-status.component';
*/



//import { HeaderComponent } from './components/header/header.component'
//import { FooterComponent } from './components/footer/footer.component';



//import { HomeModule } from './pages/home/home.module';


//import { SidenavComponent } from './components/sidenav/sidenav.component';
//import { RightSidenavComponent } from './components/right-sidenav/right-sidenav.component';


/*
import { AddNoteComponent } from './modals/add-note/add-note.component';
import { ImagePreviewComponent } from './modals/image-preview/image-preview.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SuccessMessageComponent } from './components/success-message/success-message.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import { DraftsMenuComponent } from './components/drafts-menu/drafts-menu.component';
import { SelectEmployeeComponent } from './components/select-employee/select-employee.component';
import { SelectDateComponent } from './components/select-date/select-date.component';
import { UpdateTextComponent } from './components/update-text/update-text.component';
import { ReportIssueComponent } from './components/report-issue/report-issue.component';
import { MultiSelectViewComponent } from './components/multi-select-view/multi-select-view.component';
import { SelectDropDownComponent } from './components/select-drop-down/select-drop-down.component';
import { VersionUpdatesComponent } from './components/version-updates/version-updates.component';
*/
//import { CommentTreeComponent } from './components/comment-tree/comment-tree.component';





//import { ProjectLogModule } from './pages/pmo/project-log/project-log.module';
//import { ItrakModule } from './pages/quality/itrak/itrak.module';




//SERVICES
//import { WeatherService } from './services/weather/weather.service';



/*
import { UiService } from './services/ui/ui.service';
import { IdbPowerPortalService } from './services/idb_PowerPortal/idb-power-portal.service';


import { ApplicationStateService } from './services/application-state.service';
import { AppLoadService } from './services/app-load.service';
//import { GetProjectsService } from './services/getProjects/get-projects.service';
import { Globals } from './globals';

import { HeaderService } from './components/header/header.service';



import { ExcelService } from './services/excel/excel.service';
import { SidenavService } from './components/sidenav/sidenav.service';
import { RightSidenavService } from './components/right-sidenav/right-sidenav.service';
import { SigninSsrComponent } from './pages/signin-ssr/signin-ssr.component';

import { NgtUniversalModule, WINDOW } from '@ng-toolkit/universal';
*/

//import { TransferHttpCacheModule } from '@nguniversal/common';
import { HttpClientModule } from '@angular/common/http';
import { LoadingScreenComponent } from './pages/loading-screen/loading-screen.component';


/*
import { ProjectLogComponent } from './pages/pmo/project-log/project-log.component';
import { ProjectLogSettingsComponent } from './pages/pmo/project-log/project-log-settings/project-log-settings.component';
import { ProjectLogMilestonesComponent, UpdatePercentComplete } from './pages/pmo/project-log/project-log-milestones/project-log-milestones.component';
import { ProjectLogOutOfScopeComponent, AddOutOfScopeItem } from './pages/pmo/project-log/project-log-out-of-scope/project-log-out-of-scope.component';
import { ProjectLogReportsComponent } from './pages/pmo/project-log/project-log-reports/project-log-reports.component';
import { ProjectLogLoadTemplateComponent } from './pages/pmo/project-log/project-log-settings/project-log-load-template/project-log-load-template.component';
import { ProjectLogSaveTemplateComponent } from './pages/pmo/project-log/project-log-settings/project-log-save-template/project-log-save-template.component';

import { ProjectLogCalendarComponent } from './pages/pmo/project-log/project-log-calendar/project-log-calendar.component';
import { ProjectLogAddNoteComponent } from './pages/pmo/project-log/project-log-add-note/project-log-add-note.component';
import { ProjectLogSettingsSubmilestonesComponent } from './pages/pmo/project-log/project-log-settings/project-log-settings-submilestones/project-log-settings-submilestones.component';
import { ProjectLogSettingsTasksComponent } from './pages/pmo/project-log/project-log-settings/project-log-settings-tasks/project-log-settings-tasks.component';


//ITRAK
import { ItrakComponent } from './pages/quality/itrak/itrak.component';
import { AdminItrakComponent } from './pages/quality/itrak/admin/admin.component';
import { NewItrakComponent } from './pages/quality/itrak/new-itrak/new-itrak.component';
import { UpdateItrakComponent } from './pages/quality/itrak/update-itrak/update-itrak.component';
import { TicketInformationComponent } from './pages/quality/itrak/update-itrak/ticket-information/ticket-information.component';
import { NotesComponent, AddNote } from './pages/quality/itrak/update-itrak/notes/notes.component';
import { TicketsItrakComponent, TicketFiltersViewComponent } from './pages/quality/itrak/tickets/tickets.component';
import { CapActionsComponent, AddCapAction } from './pages/quality/itrak/update-itrak/cap-actions/cap-actions.component';
import { DocumentsComponent } from './pages/quality/itrak/update-itrak/documents/documents.component';
import { HogItrakComponent } from './pages/quality/itrak/hog-itrak/hog-itrak.component';
import { SafetyTrackingItrakComponent } from './pages/quality/itrak/update-itrak/safety-tracking-itrak/safety-tracking-itrak.component';


//SAFETY
import { SafetyReportingComponent } from './pages/safety/safety-reporting/safety-reporting.component';
import { InprocessInspectionsComponent } from './pages/safety/safety-reporting/inprocess-inspections/inprocess-inspections.component';
import { CompleteInspectionsComponent } from './pages/safety/safety-reporting/complete-inspections/complete-inspections.component';
import { CorrectiveActionsComponent } from './pages/safety/safety-reporting/corrective-actions/corrective-actions.component';
import { AdminSafetyComponent } from './pages/safety/safety-reporting/admin/admin.component';
import { InspectionComponent } from './pages/safety/safety-reporting/inspection/inspection.component';
import { DocumentsInspectionComponent } from './pages/safety/safety-reporting/inspection/documents/documents.component';
import { NotesInspectionComponent, AddNoteSafetyInspection } from './pages/safety/safety-reporting/inspection/notes/notes.component';
import { NewInspectionComponent } from './pages/safety/safety-reporting/inspection/new-inspection/new-inspection.component';
import { CorrectiveActionsInprocessComponent } from './pages/safety/safety-reporting/corrective-actions/corrective-actions-inprocess/corrective-actions-inprocess.component';
import { CorrectiveActionsCompleteComponent } from './pages/safety/safety-reporting/corrective-actions/corrective-actions-complete/corrective-actions-complete.component';
import { CorrectiveActionPlanComponent } from './pages/safety/safety-reporting/corrective-actions/corrective-action-plan/corrective-action-plan.component';


//SKILLS ASSESSMENT

import { SkillsAssessmentComponent } from './pages/hr/skills-assessment/skills-assessment.component';
import { InprocessSkillsAssessmentComponent } from './pages/hr/skills-assessment/inprocess-skills-assessment/inprocess-skills-assessment.component';
import { AdminSkillsAssessmentComponent } from './pages/hr/skills-assessment/admin-skills-assessment/admin-skills-assessment.component';
import { ReportsSkillsAssessmentComponent } from './pages/hr/skills-assessment/reports-skills-assessment/reports-skills-assessment.component';
import { AssessmentSkillsAssessmentComponent } from './pages/hr/skills-assessment/assessment-skills-assessment/assessment-skills-assessment.component';
import { NewAssessmentSaComponent } from './pages/hr/skills-assessment/assessment-skills-assessment/new-assessment-sa/new-assessment-sa.component';
import { NotesAssessmentSaComponent, AddNoteSkillsAssessment } from './pages/hr/skills-assessment/assessment-skills-assessment/notes-assessment-sa/notes-assessment-sa.component';
import { DocumentsAssessmentSaComponent } from './pages/hr/skills-assessment/assessment-skills-assessment/documents-assessment-sa/documents-assessment-sa.component';
import { CompleteSkillsAssessmentComponent } from './pages/hr/skills-assessment/complete-skills-assessment/complete-skills-assessment.component';
import { SaLeaderAssessmentsComponent } from './pages/hr/skills-assessment/inprocess-skills-assessment/sa-leader-assessments/sa-leader-assessments.component';
import { SaAdminAssessmentsComponent } from './pages/hr/skills-assessment/inprocess-skills-assessment/sa-admin-assessments/sa-admin-assessments.component';
import { SaSelfAssessmentsComponent } from './pages/hr/skills-assessment/inprocess-skills-assessment/sa-self-assessments/sa-self-assessments.component';
import { SaAdminAssessmentsCompleteComponent } from './pages/hr/skills-assessment/complete-skills-assessment/sa-admin-assessments-complete/sa-admin-assessments-complete.component';
import { SaSelfAssessmentsCompleteComponent } from './pages/hr/skills-assessment/complete-skills-assessment/sa-self-assessments-complete/sa-self-assessments-complete.component';
import { SaLeaderAssessmentsCompleteComponent } from './pages/hr/skills-assessment/complete-skills-assessment/sa-leader-assessments-complete/sa-leader-assessments-complete.component';
import { SaAdminPeriodsComponent } from './pages/hr/skills-assessment/admin-skills-assessment/sa-admin-periods/sa-admin-periods.component';
import { SaSelfEmpAssessmentsComponent } from './pages/hr/skills-assessment/inprocess-skills-assessment/sa-self-emp-assessments/sa-self-emp-assessments.component';
//import { SaSelfEmpAssessmentsCompleteComponent } from './pages/hr/skills-assessment/complete-skills-assessment/sa-self-emp-assessments-complete/sa-self-emp-assessments-complete.component';
import { SaSelfempAssessmentsCompleteComponent } from './pages/hr/skills-assessment/complete-skills-assessment/sa-selfemp-assessments-complete/sa-selfemp-assessments-complete.component';


//JSA
import { JsaComponent } from './pages/jsa/jsa.component';
import { NewJsaComponent } from './pages/jsa/new-jsa/new-jsa.component';
import { ReportsJsaComponent } from './pages/jsa/reports-jsa/reports-jsa.component';
*/





//import { default as app } from 'js/app.js';


//MODALS

//import { ConfirmDialogService } from './components/confirm-dialog/confirm-dialog.service';
//import { ConfirmDialogModule } from "./components/confirm-dialog/confirm-dialog.module";  
//import { NewItrakMobileComponent } from './pages/quality/itrak/new-itrak-mobile/new-itrak-mobile.component';

//ROUTING
//import { RouterModule, UrlHandlingStrategy } from "@angular/router";

/*

export class UncaughtExceptionHandler implements ErrorHandler {
  constructor(
   // @Inject(WINDOW) private window: Window
  ) { }

  handleError(error: any) {
    //JL().fatalException('Uncaught Exception', error);
  }
}

export function init_app(appLoadService: AppLoadService) {
  return () => appLoadService.initializeApp();
}

export function get_user(appLoadService: AppLoadService) {
  return () => appLoadService.getUser();
}

*/

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

//import { MessagesModule } from 'primeng/messages';
//import { MessageModule } from 'primeng/message';

import { MessageService } from 'primeng/api';
//import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';

/*
declare var angular: angluar.IAngularStatic;
import { setAngularJSGlobal } from '@angular/upgrade/static';
setAngularJSGlobal(angular);
*/

//JL().setOptions({ "level": JL.getWarnLevel() });
import { MsalModule, MsalInterceptor } from '@azure/msal-angular';



//TESTING MSAL
/*
import {
  MSAL_CONFIG,
  MSAL_CONFIG_ANGULAR,
  MsalAngularConfiguration
  , MsalService
} from '@azure/msal-angular';
import { MSALAngularConfigFactory, MSALConfigFactory } from './modules/msal-application/msal-application.module';
//import { MSALAngularConfigFactory, MSALConfigFactory } from './modules/msal-application/msal-config';
*/






import {
  MSAL_CONFIG,
  MSAL_CONFIG_ANGULAR,
  MsalAngularConfiguration
  , MsalService,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
//import { MsalConfigService } from 'src/app/services/msal-config.service';
import { Configuration } from 'msal';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export const protectedResourceMap: [string, string[]][] = [
  ['https://graph.microsoft.com/v1.0/me', ['user.read']]
];

// This setup won't change in our environment, so we were fine with having it statically included
export const clientId = window.location.origin.includes('qa') || window.location.origin.includes('localhost') ? '<qa_id>' : '<prod_id>';

export function MSALConfigFactory(): Configuration {
  return {
    system: {
      loadFrameTimeout: 30000,
      //windowHashTimeout: 60000,
      //iframeHashTimeout: 6000,
      //windowHashTimeout: 60000,
    },
    auth: {
      clientId: 'f0ff5758-80e3-4a2a-8bf6-15951251954d',
      //authority: 'Enter_the_Cloud_Instance_Id_Here' / 'https://login.microsoftonline.com', // This is your tenant ID
      //authority: 'https://login.microsoftonline.com/90033487-bdcc-4274-8c96-80f9b090fa00', // This is your tenant ID

      authority: 'https://login.microsoftonline.com/common', // This is your tenant ID
      redirectUri: window.location.origin + "/signin/sso",
      postLogoutRedirectUri: window.location.origin + "/exit",
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
    },
  };

}

export function MSALAngularConfigFactory(): MsalAngularConfiguration {
  return {
    popUp: !isIE,
    consentScopes: [
      'user.read',
      'openid',
      'profile',
    ],
    unprotectedResources: [],
    protectedResourceMap: null,
    extraQueryParameters: {}
  }

}





import { LoggedOutComponent } from './pages/logged-out/logged-out.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';



//ADDED FOR LOWER VERSIONS IF IPHONE
const disableAnimations =
  !('animate' in document.documentElement)
  || (navigator && /iPhone OS (8|9|10|11|12|13)_/.test(navigator.userAgent));


@NgModule({
  declarations: [
    AppComponent,
    LoadingScreenComponent,
    LoggedOutComponent,
    NotFoundComponent,
    
    //  WeatherCardComponent,
    //  AddCardComponent,
    //  DetailsComponent, 
    //  FinanceReportsComponent,
    //SigninComponent,
    //SigninSsrComponent, 
    //MessageDialogComponent,
    //HeaderComponent,
    //FooterComponent,
    //HomeComponent,
    //SidenavComponent,
    //RightSidenavComponent,

    /*
    ItToolsComponent,
    HeaderComponentItrak,
    SettingsComponent,
    DbStatusComponent,
    TimeSheetValidationComponent,
    ProjectLogSettingAccessComponent,
    AddNoteComponent,
    ImagePreviewComponent,
    ConfirmDialogComponent,
    SuccessMessageComponent,
    MessageDialogComponent,
    DraftsMenuComponent,
*/
    //SelectEmployeeComponent,
    //SelectDateComponent,
    //UpdateTextComponent,
    //ReportIssueComponent,

    //MultiSelectViewComponent,
    //SelectDropDownComponent,
    //VersionUpdatesComponent,
    //CommentTreeComponent,
    
    /*
    //PROJECT LOG
    ProjectLogComponent,
    ProjectLogSettingsComponent,
    ProjectLogMilestonesComponent,
    UpdatePercentComplete,
    ProjectLogOutOfScopeComponent,
    AddOutOfScopeItem,
    ProjectLogReportsComponent,
    ProjectLogComponent,
    ProjectLogCalendarComponent,
    ProjectLogAddNoteComponent,
    ProjectLogSettingsSubmilestonesComponent,
    ProjectLogSettingsTasksComponent,
    ProjectLogLoadTemplateComponent,
    ProjectLogSaveTemplateComponent,

    //SAFETY
    SafetyReportingComponent,
    SafetyReportingComponent,
    InprocessInspectionsComponent,
    CompleteInspectionsComponent,
    CorrectiveActionsComponent,
    AdminSafetyComponent,
    InspectionComponent, DocumentsInspectionComponent, NotesInspectionComponent, AddNoteSafetyInspection,
    NewInspectionComponent,
    CorrectiveActionsInprocessComponent,
    CorrectiveActionsCompleteComponent,
    CorrectiveActionPlanComponent,


    //ITRAK
    ItrakComponent,
    ItrakComponent,
    AdminItrakComponent,
    NewItrakComponent,
    UpdateItrakComponent,
    TicketInformationComponent,
    NotesComponent, AddNote,
    CapActionsComponent, AddCapAction,
    DocumentsComponent,
    TicketsItrakComponent, TicketFiltersViewComponent,
    HogItrakComponent,
    SafetyTrackingItrakComponent,

    
    //SKILLS ASSESSMENT
    SkillsAssessmentComponent,
    SkillsAssessmentComponent,
    InprocessSkillsAssessmentComponent,
    AdminSkillsAssessmentComponent,
    ReportsSkillsAssessmentComponent,
    AssessmentSkillsAssessmentComponent,
    NewAssessmentSaComponent,
    NotesAssessmentSaComponent, AddNoteSkillsAssessment,
    DocumentsAssessmentSaComponent,
    CompleteSkillsAssessmentComponent,
    SaLeaderAssessmentsComponent,
    SaAdminAssessmentsComponent,
    SaSelfAssessmentsComponent,
    SaAdminAssessmentsCompleteComponent,
    SaSelfAssessmentsCompleteComponent,
    SaLeaderAssessmentsCompleteComponent,
    SaAdminPeriodsComponent,
    SaSelfEmpAssessmentsComponent,
    SaSelfempAssessmentsCompleteComponent,
    
    //JSA
    JsaComponent,
    NewJsaComponent,
    ReportsJsaComponent
    */

  ],
 
  imports: [
    CommonModule,

    
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    //BrowserAnimationsModule.withConfig({ disableAnimations }),
    /*
    
    //AppImportComponentsModule,
    ComponentsModule,
    */


    AppRoutingModule,
    //AppMaterialModule,
    MatProgressSpinnerModule,
    MatSnackBarModule, MatDialogModule, //MessageService,
    HttpClientModule,
    //MessagesModule, MessageModule, 
    /*
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    */
   // AngularFontAwesomeModule,
    //AccordionModule,
    //PanelModule,
    //ButtonModule,
    //RadioButtonModule,
    //NgbModalModule, 
    //UpgradeModule,
    //AngularMultiSelectModule,
    /*
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    AgGridModule.withComponents([]),
    StoreModule.forRoot({
      user: reducer
    }),
    */

    StoreModule.forRoot({
      user: reducer
    }),

    /*
    NgxMaterialTimepickerModule,
    DynamicDialogModule,
    ChartsModule,
    FileUploadModule,
    */
    //ConfirmDialogModule,

    //TESTING FOR PROD
    /*
    ServiceWorkerModule.register('ngsw-worker.js', {
      //enabled: environment.production  
      enabled: true, //TESTING FOR LOCAL HOST - JARED
    }),
    */
    ServiceWorkerModule.register('my-service-worker.js', {
      //enabled: environment.production  
      enabled: true, //TESTING FOR LOCAL HOST - JARED
    }),

    //ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    //ServiceWorkerModule.register('my-service-worker.js', { enabled: environment.production }),

    /*
    TransferHttpCacheModule,
    HttpClientModule,
    NgtUniversalModule,
    */
    /*
     * system: {
        loadFrameTimeout: 30000
      },
      */

    MDBBootstrapModule.forRoot(),


    //TEST
    MsalModule,


    /*
     * //WORKING PRODUCTION
    MsalModule.forRoot({
      system: {
        loadFrameTimeout: 30000,
        //windowHashTimeout: 60000,
        //iframeHashTimeout: 6000,
        //windowHashTimeout: 60000,
      },
      auth: {
        //clientId: 'c9fedff3-f367-4543-95d0-7072f3bee05f', // This is your client ID
        clientId: 'f0ff5758-80e3-4a2a-8bf6-15951251954d',
        //authority: 'Enter_the_Cloud_Instance_Id_Here' / 'https://login.microsoftonline.com', // This is your tenant ID
        //authority: 'https://login.microsoftonline.com/90033487-bdcc-4274-8c96-80f9b090fa00', // This is your tenant ID

        authority: 'https://login.microsoftonline.com/common', // This is your tenant ID

        redirectUri: 'https://powerportal.powergridengineering.com/signin/sso',// This is your redirect URI
        //redirectUri: 'https://powerportal.qualuscorp.com/signin/sso',// This is your redirect URI
        postLogoutRedirectUri: "https://powerportal.qualuscorp.com/exit" //QUALUSCORP - OK

        //redirectUri: 'https://powerportal.powergridengineering.com/signin/sso',// This is your redirect URI
        //postLogoutRedirectUri: "https://powerportal.powergridengineering.com/exit"

        //redirectUri: 'https://powerportal.powergridengineering.com/signin/auth',// This is your redirect URI
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      },
    }, {
        popUp: !isIE,
        consentScopes: [
          'user.read',
          'openid',
          'profile',
        ],
        unprotectedResources: [],
        protectedResourceMap: null,    
        extraQueryParameters: {}
    }),
    */



    //MessageService.forRoot(),
    //ServiceWorkerModule.register('/sw.js', { enabled: environment.production })
  ],
  entryComponents: [
    //MessageDialogComponent
    //AddNoteComponent, ImagePreviewComponent, ConfirmDialogComponent, MessageDialogComponent, DraftsMenuComponent,
    //SelectEmployeeComponent,
    //SelectDateComponent,
    //UpdateTextComponent,
    // ReportIssueComponent,
    //MultiSelectViewComponent, SelectDropDownComponent,
    //VersionUpdatesComponent,

    /*
    //PROJECT LOG
    UpdatePercentComplete, ProjectLogSaveTemplateComponent, ProjectLogLoadTemplateComponent, AddOutOfScopeItem, ProjectLogAddNoteComponent, ProjectLogSettingsSubmilestonesComponent, ProjectLogSettingsTasksComponent,
    //SAFETY
    AddNoteSafetyInspection,
    //ITRAK
    AddNote, AddCapAction, TicketFiltersViewComponent,
    //SKILLS ASSESSMENT
    //AddNoteSkillsAssessment
    */
    
  ],
  providers: [
    MessageService,
    AppEventMessagesService,
    //TEST MSAL
    {
      provide: MSAL_CONFIG,
      useFactory: MSALConfigFactory
    },
    {
      provide: MSAL_CONFIG_ANGULAR,
      useFactory: MSALAngularConfigFactory
    },
    MsalService,
  ],
  /*
  providers: [
    //WeatherService,
    //AppImportServiceModule,

    
    UiService,
    Globals,
    HeaderService,
    ApplicationStateService,
    IdbPowerPortalService,
    CookieService,  
   
    ExcelService,
    SidenavService,
    RightSidenavService,  
    DatePipe,
    

 //   ConfirmDialogService,
    { provide: ErrorHandler, useClass: UncaughtExceptionHandler },
    { provide: 'JSNLOG', useValue: JL },
    AppLoadService,
    //{ provide: APP_INITIALIZER, useFactory: init_app, deps: [AppLoadService], multi: true },
    { provide: APP_INITIALIZER, useFactory: get_user, deps: [AppLoadService], multi: true }
    

  ],
  */
  //exports: [AppImportComponentsModule],

  //exports: [SigninComponent],


  //GetProjectsService
  bootstrap: [AppComponent],
  schemas: [ NO_ERRORS_SCHEMA ]
})
export class AppModule {
  //constructor(private upgrade: UpgradeModule) { }
  /*
  ngDoBootStrap() {
    console.log('AppModule ngDoBootstrap');
    this.upgrade.bootstrap
 constructor(@Inject(WINDOW) private window: Window) {}
(document.body, ['app'], { strictDi: true })
  }
  */
}





//platformBrowserDynamic().bootstrapModule(AppModule);

//platformBrowserDynamic().bootstrapModule(AppModule)
//setAngularJSGlobal(window['angular']);


/*
//declare var angular: angular.IAngularStatic;
setAngularJSGlobal(window['angular']);

platformBrowserDynamic().bootstrapModule(AppModule).then(platformRef => {
  console.log('Hybrid mode: Angular + Angular.Js');
  app.directive('appRoot', downgradeComponent({ component: AppComponent }));
  const upgrade = platformRef.injector.get(UpgradeModule) as UpgradeModule;
  console.log('bootstrapModule: ', app.name);
  //main['launchAngular']();
  upgrade.bootstrap(document.body, [app.name], { strictDi: true });
});
*/
